module.exports = __webpack_public_path__ + "static/media/CastleKuiMulangNightINTA0014_design_clean_v002.c6cd4c80.webp";